import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=3634ceda"
import script from "./Attributes.vue?vue&type=script&defer=true&lang=js"
export * from "./Attributes.vue?vue&type=script&defer=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports